export default __webpack_public_path__ + "static/media/footer-chatwithus-icon.2fd58f2c.svg";